import { toast } from "react-toastify";
import api from "../../Utils/api";

export default function Unavailability({ unavailabilities, getSchedule }) {
  const deleteUnavailable = async (id) => {
    const res = await api.delete(`/unavailable/${id}`);
    if (res.data.success) {
      toast.success(res.data.message);
      getSchedule();
    }
  };

  return (
    <div className="p-6">
      {/* Work Details Card */}
      <section className="bg-white mb-16">
        <h2 className="text-gray-800 font-semibold text-lg mb-4">
          Unavailabilities
        </h2>
        <hr className="w-full mb-2 mt-2" />

        {unavailabilities?.map((item) => {
          const start = new Date(item.startTime).getTime();
          const end = new Date(item.endTime).getTime();

          // Calculate days difference (inclusive)
          const msPerDay = 60 * 60 * 1000;
          const hours = Math.round((end - start) / msPerDay);

          // Format dates, e.g. "Mon 21 Apr 2025"

          const startFormatted = item.startTime.slice(0, 16).replace("T", " ");
          const endFormatted = item.endTime.slice(0, 16).replace("T", " ");

          return (
            <div
              key={item._id}
              className="bg-gray-50 p-4 relative w-full mb-4 rounded shadow-sm"
            >
              <div className="flex justify-between items-center mb-2">
                <h3 className="text-gray-800 font-semibold">
                  {hours} Hour{hours > 1 ? "s" : ""}
                </h3>
                <button
                  className="text-red-500 text-sm hover:underline"
                  onClick={() => deleteUnavailable(item._id)}
                  type="button"
                >
                  Remove
                </button>
              </div>
              <div className="">
                <p className="text-gray-700 text-sm mb-2">
                  {startFormatted} &rarr; {endFormatted}
                </p>
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
